import { createSelector } from 'reselect';
import _ from 'lodash';

const SeminarManagementSelector = {
    createPaginationListAllSeminarSelector: () => createSelector([
        (state) => state.seminars.listSeminars.data,
    ], (data) => {
        if (!_.isEmpty(data)) {
            return {
                total_length: data.total_length,
                total_page: data.total_page,
                page: data.page,
                page_size: data.page_size,
            };
        }
        return {};
    }),
};

export default SeminarManagementSelector;
